export const GET_PRICE_PLANS_SUCCESS = 'GET_PRICE_PLANS_SUCCESS';
export const SET_PRICE_PLANS_LOADING = 'SET_PRICE_PLANS_LOADING';
export const SET_PRICE_PLANS_ERROR = 'SET_PRICE_PLANS_ERROR';

export const GET_PAYMENT_PORTAL_SUCCESS = 'GET_PAYMENT_PORTAL_SUCCESS';
export const SET_PAYMENT_PORTAL_LOADING = 'SET_PAYMENT_PORTAL_LOADING';
export const SET_PAYMENT_PORTAL_ERROR = 'SET_PAYMENT_PORTALNS_ERROR';
